export default function initResults() {
  Alpine.data('results', () => ({
    selectedTab: ((new Date()).getFullYear()).toString(),
    showMoreTabs: false,
    isDragging: false,
    startX: 0,
    scrollLeft: 0,

    init() {
      const activeTabBtn: HTMLElement|null = this.$el.querySelector('button.active');
      if (activeTabBtn && activeTabBtn.dataset.tab) {
        this.selectedTab = activeTabBtn.dataset.tab;
      }

      this.$watch('selectedTab', () => {
        const btns = this.$root.getElementsByTagName('button');
        Array.from(btns).forEach((btn) => {
          const btnTab = btn.dataset.tab;
          if (btnTab && this.selectedTab === btnTab) {
            btn.classList.add('active');
          } else {
            btn.classList.remove('active');
          }
        });

        const results = this.$root.getElementsByClassName('results');
        for (let result of results) {
          if (result instanceof HTMLElement && result.dataset) {
            const resultTab = result.dataset.tab;
            if (resultTab && this.selectedTab === resultTab) {
              result.classList.remove('hidden');
            } else {
              result.classList.add('hidden');
            }
          }
        }

        this.showMoreTabs = false;
      });

      this.$watch('showMoreTabs', () => {
        const btnTabGroup: HTMLElement|null = this.$root.querySelector('[class*="group/btn-tabs"]');
        btnTabGroup?.classList.toggle('active');
        const btn = btnTabGroup?.querySelector('button');
        if (btn) {
          btn.ariaExpanded = this.showMoreTabs ? 'true' : 'false';
        }
      })

      const results = this.$root.querySelector('.results-nav') as HTMLElement|null;
      if (results) {
        results.addEventListener('mousedown', (e) => {
          this.isDragging = true;
          this.startX = e.pageX - results.offsetLeft;
          this.scrollLeft = results.scrollLeft;
        });

        results.addEventListener('mouseleave', () => {
          this.isDragging = false;
        });

        results.addEventListener('mouseup', () => {
          this.isDragging = false;
        });

        results.addEventListener('mousemove', (e) => {
          if (!this.isDragging) return;
          e.preventDefault();
          const x = e.pageX - results.offsetLeft;
          const walk = x - this.startX;
          results.scrollLeft = this.scrollLeft - walk;
        });

        results.addEventListener('touchstart', (e) => {
          this.isDragging = true;
          this.startX = e.touches[0].pageX - results.offsetLeft;
          this.scrollLeft = results.scrollLeft;
        });

        results.addEventListener('touchend', () => {
          this.isDragging = false;
        });

        results.addEventListener('touchmove', (e) => {
          if (!this.isDragging) return;
          e.preventDefault();
          const x = e.touches[0].pageX - results.offsetLeft;
          const walk = x - this.startX;
          results.scrollLeft = this.scrollLeft - walk;
        });
      }
    },

    selectTab() {
      if (this.$el.dataset.tab) {
        this.selectedTab = this.$el.dataset.tab;
      }
    },

    toggleMoreTabs() {
      this.showMoreTabs = !this.showMoreTabs;
    },
  }))
}